// removed by extract-text-webpack-plugin
module.exports = {"createButton":"_2hHI","statusDropdown":"_3SK6","searchBox":"_2ZC_","refColumn":"MfUJ","statusColumn":"wTEl","flowsColumn":"KFah"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Numbers/Numbers.scss
// module id = 7h6j
// module chunks = 0